import clsx from 'clsx';

export function ImportantCtaBoxIcon({
    icon,
    circle,
    color,
}: {
    icon: React.ReactNode;
    circle?: boolean;
    color: 'primary' | 'purple';
}) {
    const colorClass = {
        primary: 'bg-primary',
        purple: 'bg-purple',
    }[color];

    if (!icon) {
        return null;
    }

    return (
        <div data-id="important-cta-box-icon" className="mb-3 flex items-center justify-center">
            <div
                className={clsx('flex h-7.5 w-7.5 items-center justify-center text-base', {
                    [`${colorClass} rounded-full p-2 text-white`]: circle,
                })}
            >
                {icon}
            </div>
        </div>
    );
}
